const { LOAD_DEVICE_DETAILS } = require('../constants/commonEvents')
const { DEVICE_STATUS } = require('../constants/devices/deviceStatuses')
import { NOTIFICATIONS_TYPE } from '../constants/notificationsConstants'
const {
  DEFAULT_NOTIFICATION_INTERVAL,
  SHORT_NOTIFICATION_INTERVAL,
  SHORT_NOTIFICATION_INTERVAL_DURATION
} = require('../constants/notificationsConstants')
const { USER_ROLES } = require('../constants/userDetails')

angular.module('surfsightApp.controllers').controller('homeCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdToast',
  '$mdTheming',
  '$mdColors',
  '$mdMedia',
  'edgeFactory',
  'edgeFactoryV2',
  'edgeGroupFactory',
  'edgeGroupFactoryV2',
  'broadcastViewFactory',
  'notificationsFactory',
  'leafletData',
  'leafletBoundsHelpers',
  'nominatimLookUp',
  '$transitions',
  '$translate',
  'jwtHelper',
  function (
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdToast,
    $mdTheming,
    $mdColors,
    $mdMedia,
    edgeFactory,
    edgeFactoryV2,
    edgeGroupFactory,
    edgeGroupFactoryV2,
    broadcastViewFactory,
    notificationsFactory,
    leafletData,
    leafletBoundsHelpers,
    nominatimLookUp,
    $transitions,
    $translate,
    jwtHelper
  ) {
    $rootScope.recordingStreamQualities = window.recordingStreamQualities
    $rootScope.DEVICE_STATUS = DEVICE_STATUS
    const browserInfo = window.getBrowserInfo()
    $rootScope.browserInfo = browserInfo
    $rootScope.openDownloadsInNewTab = browserInfo.config.openDownloadsInNewTab
    var languageKey = 'en'
    if (!$localStorage.selectedLanguage) {
      $scope.language_code = 'EN'
      $scope.language_flag = 'flag-icon-us'
    } else {
      $scope.language_code = $localStorage.selectedLanguage.lang_code
      $scope.language_flag = $localStorage.selectedLanguage.flag
      languageKey = $localStorage.selectedLanguage.language_key
    }
    $translate.use(languageKey)
    $scope.showAlarmsIcon = true
    moment.locale($scope.language_code.toLowerCase())
    $scope.events_list = []
    $scope.heading_text = 'SurfSight'
    $scope.icon_text = 'menu'
    $scope.status = false
    $scope.currentState = $state.current.name
    let locationSearch = $location.search()
    if ($scope.currentState == 'home.common.events.history') {
      if (locationSearch.type == 'show_event_video') {
        let deeplinkEventVideo = {
          show: false,
          completed: false
        }
        deeplinkEventVideo.show = true
        deeplinkEventVideo.edge_id = $stateParams.imei
        deeplinkEventVideo.msg_type = locationSearch.msg_type
        deeplinkEventVideo.time = locationSearch.time
        deeplinkEventVideo.lat = locationSearch.lat
        deeplinkEventVideo.lon = locationSearch.lon
        deeplinkEventVideo.file_id = locationSearch.file_id
        deeplinkEventVideo.file_id_rear = locationSearch.file_id_rear
        deeplinkEventVideo.orgId = locationSearch.orgId
        deeplinkEventVideo.type = locationSearch.type
        $localStorage.deeplinkEventVideo = angular.copy(deeplinkEventVideo)
      }
    }

    $scope.$on('organizationChanged', function (e, organization) {
      if ($localStorage.deeplinkEventVideo) {
        $localStorage.deeplinkEventVideo.shown = true
      }
      $rootScope.currentUserOrganization = organization
      edgeFactory.list.splice(0, edgeFactory.list.length)
      edgeFactoryV2.clear()
      edgeGroupFactory.list.splice(0, edgeGroupFactory.list.length)
      edgeGroupFactoryV2.clear()
      broadcastViewFactory.list.splice(0, broadcastViewFactory.list.length)
      $scope.alarmsExists = $rootScope.alarmsCount
      $scope.loadBroadcastViews()
    })

    $interval(() => {
      if (!$localStorage.isResellerSso) return
      if (
        $localStorage.userToken &&
        (jwtHelper.isTokenExpired($localStorage.userToken) ||
          $localStorage.resellerSsoExpireTime < new Date().getTime())
      ) {
        delete $localStorage.userToken
        delete $localStorage.isResellerSso
        $state.go('home.login')
      }
    }, 10000)
    const syncUserSettings = () => {
      let userSettings = {}
      $http({
        method: 'GET',
        url: `${USER_BASEURL}/user/settings`
      })
        .then(response => {
          if (response.data.status.code === 0) {
            userSettings = response.data.userSettings
            $localStorage.userDetails.userSettings = userSettings
          }
        })
        .catch(error => {
          handleServerError(error)
        })
        .finally(() => {
          $localStorage.measurementUnits = userSettings.mesaurement || 1
          $localStorage.timeFormat = userSettings.timeFormat || 2
        })
    }
    $scope.isAlreadyLogin = function () {
      if (
        $stateParams.jwtToken &&
        $stateParams.organizationId &&
        $state.current.name === 'home.common.reseller-sso'
      ) {
        // if($stateParams.jwtToken === $localStorage.userToken) return
        const { jwtToken } = $stateParams
        const organizationId = parseInt($stateParams.organizationId)
        const resellerDetails = jwtHelper.decodeToken(jwtToken)
        resellerDetails.permission_role = 'administrator'
        resellerDetails.organizationId = organizationId
        $localStorage.isResellerSso = true
        $localStorage.resellerSsoExpireTime =
          new Date().getTime() + 30 * 60 * 1000
        $localStorage.userDetails = resellerDetails

        $localStorage.userToken = jwtToken
        $localStorage.currentUserOrganization = {
          id: organizationId
        }
        delete $localStorage.userOrganization
        syncUserSettings()
        $state.go('home.common.edge.list')
      }
      if ($localStorage.userToken && $localStorage.isResellerSso) {
        if ($localStorage.resellerSsoExpireTime < new Date().getTime()) {
          delete $localStorage.userToken
          return false
        }
      }
      if ($localStorage.userToken) {
        $rootScope.currentUserOrganization = {
          id: $localStorage.currentUserOrganization.id
        }
        getOrganizationDetails()
        return true
      }
      return false
    }
    const getOrganizationDetails = () => {
      if (
        $localStorage.deeplinkEventVideo &&
        $localStorage.deeplinkEventVideo.show &&
        !$localStorage.deeplinkEventVideo.shown
      ) {
        $rootScope.currentUserOrganization.id =
          $localStorage.deeplinkEventVideo.orgId
      }
      $rootScope.currentUserOrganization.id &&
        $http({
          method: 'GET',
          url:
            USER_BASEURL +
            '/organization/' +
            $rootScope.currentUserOrganization.id
        }).then(function (response) {
          const organizationDetails =
            response.data && response.data.organization
          if (organizationDetails && organizationDetails.name) {
            organizationDetails.name = organizationDetails.name.replace(
              /&amp;/g,
              '&'
            )
          }
          $localStorage.userOrganization = organizationDetails
          $localStorage.currentUserOrganization = organizationDetails
          $rootScope.alarmsCount = organizationDetails.alarmsCount
          if (organizationDetails.alarmsCount > 0) {
            $scope.alarmsExists = true
          }
        })
    }
    $interval(() => {
      getOrganizationDetails()
    }, 300000)
    if (!$scope.isAlreadyLogin()) {
      $state.go('home.login')
      return false
    }
    var checkMediaTokenAccessTimeout = null
    $scope.generateMediaAccessToken = function () {
      $http({
        method: 'GET',
        url: MEDIACORE_BASEURL + '/generate_authtoken'
      }).then(
        function (response) {
          if (response.data.status.code === 0) {
            $localStorage.userMediaAccessToken = response.data.token
            $scope.$broadcast('updateMediaToken', {
              mediaToken: response.data.token
            })
            $scope.checkMediaTokenAccess()
          }
        },
        function (response) {
          handleServerError(response)
          checkMediaTokenAccessTimeout = $timeout(
            $scope.checkMediaTokenAccess,
            30000
          )
        }
      )
    }
    const handleWindowFocus = () => {
      if (checkMediaTokenAccessTimeout) {
        $timeout.cancel(checkMediaTokenAccessTimeout)
        checkMediaTokenAccessTimeout = null
      }
      $scope.checkMediaTokenAccess()
    }
    $window.addEventListener('focus', handleWindowFocus)
    $scope.checkMediaTokenAccess = function () {
      if (!$localStorage.userMediaAccessToken) {
        return
      }
      $http({
        method: 'POST',
        url:
          MEDIACORE_BASEURL +
          '/validate_authtoken/' +
          $localStorage.userMediaAccessToken,
        data: {}
      }).then(function (response) {
        if (checkMediaTokenAccessTimeout) {
          $timeout.cancel(checkMediaTokenAccessTimeout)
          checkMediaTokenAccessTimeout = null
        }
        checkMediaTokenAccessTimeout = $timeout(function () {
          $scope.generateMediaAccessToken()
        }, (response.data.expiration - 5) * 1000)
      }, $scope.generateMediaAccessToken)
    }
    $scope.checkMediaTokenAccess()
    $scope.checkStates = function () {
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.sideStripe_status = false
      }
      $scope.showAlarmsIcon = true
      var edge_id = $state.params.edge_id || $state.params.deviceId
      var edge = edgeFactory.findItemById(edge_id).item
      if (edge == undefined) {
        $scope.deviceName = ''
      } else {
        $scope.deviceName = '- ' + edge.name
      }
      $scope.$broadcast('stopBroadcasts', {})
      var stateName = $state.current.name
      $scope.sideStripe_list.forEach(function (e, i) {
        e.opened = false
      })
      if (stateName === 'home.common.recordings.list') {
        $scope.heading_text = 'recordings'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
        $scope.sideStripe_list[2].opened = true
        $scope.selected_sideStripe_menu = 3
      } else if (stateName === 'home.common.recordings.timeline') {
        $scope.heading_text = 'recordingsTimeline'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
        $scope.sideStripe_list[2].opened = true
        $scope.selected_sideStripe_menu = 3
      } else if (
        ['home.common.events.history', 'home.common.events.dashboard'].indexOf(
          stateName
        ) > -1
      ) {
        $scope.heading_text = 'eventDetails'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
        $scope.sideStripe_list[3].opened = true
        $scope.selected_sideStripe_menu = 4
      } else if (stateName == 'home.common.maps.view') {
        $scope.heading_text = 'maps'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(2)
        $scope.$broadcast('currentState', { stateName })
      } else if (stateName == 'home.common.maps.geofence') {
        $scope.heading_text = 'geofence'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
        $scope.sideStripe_list[1].opened = true
        $scope.selected_sideStripe_menu = 2
        $scope.openSideNav('geofence-list')
        $scope.openSideNav('edges-map-sidenav')
        leafletData.getMap().then(function (map) {
          $timeout(function () {
            map.invalidateSize()
          }, 300)
        })
        $scope.$broadcast('currentState', { stateName })
      } else if (stateName === 'home.common.maps.edgeTrips') {
        $scope.heading_text = 'trips'
        $scope.icon_text = 'arrow_back'
        $scope.status = true

        if (!$rootScope.isUserMapViewer()) {
          $scope.sideStripe_list[1].opened = true
        } else {
          $scope.sideStripe_list[0].opened = true
        }
        $scope.selected_sideStripe_menu = 2
        $scope.openSideNav('trips-list')
        $scope.openSideNav('edges-map-sidenav')
        leafletData.getMap().then(function (map) {
          $timeout(function () {
            map.invalidateSize()
          }, 300)
        })
        $scope.$broadcast('currentState', { stateName })
      } else if (stateName === 'home.common.events') {
        $scope.heading_text = 'events'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(4)
      } else if (stateName === 'home.common.recordings') {
        $scope.heading_text = 'recordings'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(3)
      } else if (stateName === 'home.common.edge.list') {
        $scope.heading_text = 'cameras'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(1)
      } else if (stateName === 'home.common.settings') {
        $scope.heading_text = 'settings'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(6)
      } else if (stateName === 'home.common.maps.geofence') {
        $scope.heading_text = 'geofence'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
        $scope.select_sideStripe_menu(2)
      } else if (stateName === 'home.common.reports') {
        $scope.heading_text = 'reports'
        $scope.icon_text = 'menu'
        $scope.status = false
        $scope.select_sideStripe_menu(5)
      } else if (stateName === 'home.common.healthReports') {
        $scope.heading_text = 'health'
        if ($state.params.healthReportType) {
          $scope.icon_text = 'arrow_back'
          $scope.status = true
        } else {
          $scope.icon_text = 'menu'
          $scope.status = false
        }
        $scope.showAlarmsIcon = false
        $scope.select_sideStripe_menu(7)
      } else if (
        [
          'home.common.reports.edge',
          'home.common.reports.edgegroup',
          'home.common.reports.edgereportDashboard',
          'home.common.reports.edgegroupreportDashboard'
        ].indexOf(stateName) > -1
      ) {
        $scope.heading_text = 'reports'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
        $scope.sideStripe_list[4].opened = true
      }

      if ($mdMedia('gt-sm')) {
        $scope.icon_text = 'menu'
      }
    }
    $scope.controlInit = function () {
      $timeout(function () {
        $scope.checkStates()
      })
    }
    $scope.controlInit()
    $transitions.onSuccess({}, function () {
      if (!$scope.isAlreadyLogin()) {
        $state.go('home.login')
        return
      }
      $timeout(function () {
        $scope.checkStates()
      })
    })
    $scope.sideNav_list = []
    $scope.showLanguages = ev => {
      $mdDialog
        .show({
          controller: 'languageController',
          templateUrl:
            './templates/language.change.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {
            $scope.language_code = response.lang_code
            $scope.language_flag = response.flag
            $scope.$broadcast('languageChange', { response })
          },
          () => {}
        )
    }
    $scope.userDetails = $localStorage.userDetails

    $rootScope.isUserMapViewer = function () {
      return (
        $localStorage.userDetails &&
        $localStorage.userDetails.permission_role === USER_ROLES.USER_MAP_VIEWER
      )
    }

    $scope.scrollbarConfig = {
      theme: 'dark-2',
      scrollInertia: 500,
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: false // enable scrolling buttons by default
      }
    }
    $scope.scrollbarEdge = {
      theme: 'dark-thick',
      scrollInertia: 500,
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: false // enable scrolling buttons by default
      }
    }

    $scope.logout = function () {
      $state.go('logout')
    }
    $scope.fetchNotifications = function () {
      // On click of notification icon, fetch notifications
      $rootScope.$emit('fetchNotificationsEvent')
    }
    $scope.showDesktopNotifications = function ($mdMenu, event) {
      this.fetchNotifications()
      $scope.hasNotifications = false
      // Open the menu to display notifications
      $mdMenu.open(event)
    }
    $scope.showMobileNotifications = ev => {
      $mdDialog
        .show({
          controller: 'notificationItemCtrl',
          templateUrl:
            './templates/notification-item.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(() => {})
        .catch(() => {})
      // Ensure `fetchNotifications` is called after modal is fully rendered
      $timeout(() => {
        $scope.hasNotifications = false
        $scope.fetchNotifications()
      }, 300)
    }

    // Logic to keep notification polling dynamic. Short Polling incase user requests recording Download file.
    let currentInterval = DEFAULT_NOTIFICATION_INTERVAL
    let pollingTimer
    let shortIntervalTimeout = 0

    const startShortIntervalNotificatioPolling = () => {
      currentInterval = SHORT_NOTIFICATION_INTERVAL
      startNotificationPolling()

      if (shortIntervalTimeout) {
        $timeout.cancel(shortIntervalTimeout)
      }
      shortIntervalTimeout = $timeout(() => {
        currentInterval = DEFAULT_NOTIFICATION_INTERVAL
        startNotificationPolling()
      }, SHORT_NOTIFICATION_INTERVAL_DURATION)
    }
    // Event listener to ui-components
    const handleComponentEvent = event => {
      if (event.detail.eventType === 'recordingDownloadFileAlreadyAvailable') {
        $scope.showMessageToast(
          $filter('translate')('recordingAlreadyAvailable')
        )
      } else if (
        event.detail.eventType === 'recordingTimelineDownloadRequested'
      ) {
        $scope.$broadcast('$downloadRecordingRequested', '')
        startShortIntervalNotificatioPolling()
      }
    }
    const handleReportComponentEvent = event => {
      if (event.name === 'reportDownloadRequested') {
        startShortIntervalNotificatioPolling()
      }
    }
    $window.addEventListener('componentEvent', handleComponentEvent)
    const destroyReportDownloadRequested = $scope.$on(
      'reportDownloadRequested',
      handleReportComponentEvent
    )

    $rootScope.$on('RecordingRequestedWithTryAgainEvent', () => {
      startShortIntervalNotificatioPolling()
    })
    $scope.stopPing = () => {
      $interval.cancel(pollingTimer)
    }
    function startNotificationPolling () {
      if (pollingTimer) {
        $scope.stopPing()
      }
      pollingTimer = $interval(() => {
        notificationsFactory
          .checkUnReadNotifications()
          .then(async notifications => {
            const downloadNotifications =
              notifications &&
              notifications.filter(
                notification =>
                  NOTIFICATIONS_TYPE[notification.type].requiredPresignedLink &&
                  notification.metadata.status === 'completed' &&
                  notification.metadata.autoDownloaded === false
              )
            if (downloadNotifications && downloadNotifications.length) {
              await notificationsFactory.handleDownloadNotification(
                downloadNotifications
              )
            }
            $scope.hasNotifications = notifications && notifications.length > 0
          })
          .catch(error => $scope.$emit('handleServerError', error))
      }, currentInterval)
    }
    $scope.mdMedia = function (q) {
      return $mdMedia(q)
    }

    $scope.sideStripe_list = [
      {
        id: 1,
        name: 'cameras',
        icon: 'camera_alt'
      },
      {
        id: 2,
        name: 'maps',
        icon: 'place'
      },
      {
        id: 3,
        name: 'recordings',
        icon: 'videocam'
      },
      {
        id: 4,
        name: 'events',
        icon: 'event'
      },
      {
        id: 5,
        name: 'analytics',
        icon: 'timeline'
      },
      {
        id: 7,
        name: 'reports',
        icon: 'table_chart'
      },
      {
        id: 6,
        name: 'settings',
        icon: 'settings'
      }
    ]

    if (122735 === $rootScope.currentUserOrganization.id) {
      $scope.sideStripe_list = [
        {
          id: 4,
          name: 'events',
          icon: 'event'
        },
        {
          id: 6,
          name: 'settings',
          icon: 'settings'
        }
      ]
    }

    if ($rootScope.isUserMapViewer()) {
      $scope.sideStripe_list = [
        {
          id: 2,
          name: 'maps',
          icon: 'place'
        }
      ]
    }

    $scope.sideStripe_status = true
    $scope.toggle_sideStripe = function (status = false) {
      var stateName = $state.current.name
      if (status) {
        $scope.sideStripe_status = false
        if ($mdMedia('xs') || $mdMedia('sm')) {
          if ($state.$current.includes['home.common.recordings']) {
            $state.go('home.common.recordings')
            $mdSidenav('recordings-timeline-container').close()
          } else if (stateName === 'home.common.events.history') {
            $state.go('home.common.events')
          } else if (stateName === 'home.common.events.dashboard') {
            $state.go('home.common.events')
          } else if (
            stateName === 'home.common.reports.edge' ||
            stateName === 'home.common.reports.edgegroup'
          ) {
            $state.go('home.common.reports')
          } else if (stateName === 'home.common.reports.edgereportDashboard') {
            $state.go('home.common.reports.edge', {
              edge_id: $state.params.edge_id
            }) // home.common.healthReports
          } else if (stateName === 'home.common.healthReports') {
            $state.go('home.common.healthReports', {
              healthReportType: null
            })
            $scope.icon_text = 'menu'
            $scope.status = false
          } else if (
            stateName === 'home.common.reports.edgegroupreportDashboard'
          ) {
            $state.go('home.common.reports.edgegroup', {
              edge_group_id: $state.params.edge_group_id,
              edge_id: $state.params.edge_id
            })
          } else if (stateName === 'home.common.maps.geofence') {
            if ($mdSidenav('geofence-list').isOpen()) {
              $state.go('home.common.maps.view')
            } else {
              $scope.openSideNav('geofence-list')
            }
            $scope.heading_text = 'geofence'
            $scope.icon_text = 'arrow_back'
            $scope.status = true
          } else if (stateName === 'home.common.maps.edgeTrips') {
            if ($mdSidenav('trips-list').isOpen()) {
              $state.go('home.common.maps.view')
            } else {
              $scope.openSideNav('trips-list')
            }
            $scope.openSideNav('trips-list')
            $scope.heading_text = 'trips'
            $scope.icon_text = 'arrow_back'
            $scope.status = true
          } else if (stateName === 'home.common.maps.view') {
            $scope.openSideNav('edge-list')
            $scope.heading_text = 'maps'
            $scope.icon_text = 'menu'
            $scope.status = false
          }
        }
      } else {
        $scope.sideStripe_status = !$scope.sideStripe_status
      }
    }
    $scope.selected_sideStripe_menu = 1
    $scope.opened_sidestripe_id = 1
    $scope.sideStripe_changed = false
    $scope.select_sideStripe_menu = function (id) {
      var sideStripe = {}
      $scope.sideStripe_list.forEach(function (list) {
        if (list.id == id) {
          sideStripe = list
        }
      })
      var id = sideStripe.id
      if (id != $scope.selected_sideStripe_menu) {
        $scope.sideStripe_changed = true
      }
      $scope.selected_sideStripe_menu = id
      var sideStripe_index = $scope.sideStripe_list.indexOf(sideStripe)
      if (id === 1) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'cameras'
          $scope.openSideNav('edge-list')
        }
        $state.go('home.common.edge.list')
      } else if (id === 2) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'maps'
        }
        $state.go('home.common.maps.view')
      } else if (id === 3) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'recordings'
        }
        $state.go('home.common.recordings')
      } else if (id === 4) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'events'
        }
        $state.go('home.common.events')
      } else if (id === 5) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'reports'
        }
        $state.go('home.common.reports')
      } else if (id === 6) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'settings'
        }
        $state.go('home.common.settings')
      } else if (id === 7) {
        if ($mdMedia('xs') || $mdMedia('sm')) {
          $scope.heading_text = 'health'
        }
        $state.go('home.common.healthReports')
      }
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.sideStripe_status = false
      }
      $scope.sideStripe_list.forEach(function (e, i) {
        e.opened = false
        $scope.sideStripe_list[i] = e
      })
      sideStripe.opened = true
      $scope.sideStripe_list[sideStripe_index] = sideStripe
      $scope.sideStripe_changed = false
    }
    if ($rootScope.isUserMapViewer()) {
      $rootScope.$on('$locationChangeSuccess', function (
        event,
        newUrl,
        oldUrl
      ) {
        if (
          !newUrl.includes('maps') &&
          !newUrl.includes('logout') &&
          !newUrl.includes('trips')
        ) {
          $scope.select_sideStripe_menu(2)
        }
      })
    }
    $scope.themePrimary = $mdColors.getThemeColor('primary')
    $scope.themeAccent = $mdColors.getThemeColor('accent')
    $scope.toggleSideNav = function (sidenav_id = 'left-sidenav') {
      $mdSidenav(sidenav_id).toggle()
    }
    $scope.openSideNav = function (sidenav_id) {
      $mdSidenav(sidenav_id).open()
    }
    $scope.closeSideNav = function (sidenav_id) {
      $mdSidenav(sidenav_id).close()
    }
    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .actionKey('F1')
        .textContent(message)
        .action($filter('translate')('ok'))
        .position('top right')
        .hideDelay(5000)

      $mdToast
        .show(toast)
        .then(() => {})
        .catch(() => {})
    }
    $scope.$on('$destroy', function () {
      if (angular.isDefined($rootScope.timer)) {
        $interval.cancel($rootScope.timer)
        $rootScope.timer = null
      }
      checkMediaTokenAccessTimeout &&
        $timeout.cancel(checkMediaTokenAccessTimeout)
      $window.removeEventListener('focus', handleWindowFocus)
      $window.removeEventListener('componentEvent', handleComponentEvent)
      $window.removeEventListener(
        'reportDownloadRequested',
        handleReportComponentEvent
      )
      destroyReportDownloadRequested()
      $scope.stopPing()
    })
    $scope.$on('dashcamStreamsAddedRequest', function (e, data) {
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.closeSideNav('edge-list')
        $scope.openSideNav('multiple-braodcast-videos')
      }
      $scope.$broadcast('dashcamStreamsAdded', { data })
    })
    $scope.$on('broadcastViewRequest', function (e, data) {
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.closeSideNav('edge-list')
        $scope.openSideNav('multiple-braodcast-videos')
      }
      $scope.$broadcast('broadcastViewReceive', data)
    })
    $scope.$on('geofenceData', function (e, data) {
      $scope.$broadcast('geofenceData', { data })
    })
    if (!$rootScope.isUserMapViewer()) {
      $scope.$on('tripsData', function (e, data) {
        $scope.$broadcast('tripsDataEmit', { data })
      })
    }
    $scope.$on('eventSearchData', function (e, eventSearchData) {
      $scope.$broadcast('eventSearchDataResult', { eventSearchData })
    })
    $scope.$on('aggressiveSearchData', function (e, eventSearchData) {
      $scope.$broadcast('aggressiveSearchDataEmit', { eventSearchData })
    })

    $scope.$on('closeBroadcastView', function (e, data) {
      $scope.$broadcast('closeBroadcastVie', {})
    })
    $scope.$on('mapSidenavOpenEvent', function (e, data) {
      $scope.$broadcast('mapSidenavOpen', { data })
    })
    $scope.$on('changeMapCenterEvent', function (e, data) {
      $scope.$broadcast('changeMapCenter', { data })
    })
    $scope.$on('selectedTrips', function (e, data) {
      $scope.$broadcast('selectedTripsEmit', { data })
    })
    $scope.$on('mapEvent', function (e, data) {
      if ($mdMedia('xs') || $mdMedia('sm')) {
        $scope.heading_text = 'mapDetails'
        $scope.icon_text = 'arrow_back'
        $scope.status = true
      }
      $scope.$broadcast('mapFirstZoom', {})
    })
    $scope.$on('sideStripToggle', function (e, data) {
      $scope.sideStripe_status = false
    })
    $scope.$on('recordingVideoAdded', (e, data) => {
      $scope.$broadcast('recordingVideoAddedEmit', data)
    })
    $scope.currentSideNavAddBtn = function ($event) {
      $scope.$broadcast('currentSideNavAddBtnReceive', { $event })
    }
    $scope.getCurrentState = function () {
      return $state.current.name
    }
    $scope.$on('mapHistoryEvent', function (e, data) {
      $scope.$broadcast('mapHistorySend', { data })
    })
    $scope.$on('handleServer', function (e, data) {
      handleServerError(data)
    })
    $scope.$on('handleServerError', function (e, data) {
      handleServerError(data)
    })
    $scope.$on('geoJSON_data', function (e, data) {
      $scope.$broadcast('geoJSON_dataEmit', { data })
    })
    $scope.$on('loadGeofencePaths', function (e, data) {
      $scope.$broadcast('loadGeofencePathsEmit', data)
    })
    $scope.$on('geofenceEvent', function (e, data) {
      $scope.$broadcast('geofenceEvntSend', data)
    })
    $scope.$on('loadGeofenceData', function (e, data) {
      $scope.$broadcast('loadGeofenceDataCall', data)
    })
    $scope.$on('loadEdgesEvt', function (e, data) {
      $scope.$broadcast('loadEdgesBrdcst', data)
    })
    $scope.$on('clearGeofence', function (e, data) {
      $scope.$broadcast('clearGeofenceLayer', data)
    })
    $scope.$on('eventsVideoAdded', function (e, data) {
      $scope.$broadcast('eventsVideoAddedEmit', data)
    })
    $scope.$on('eventsRecordingsPlayerAdded', (_, data) => {
      $scope.$broadcast('eventsRecordingsPlayerAddedEmit', data)
    })
    $scope.$on('showReportTableEmit', function (e, data) {
      $scope.$broadcast('showReportTableReceive', data)
    })
    $scope.$on('SHOW_REPORT_DATE_FILTER_EMIT', (e, data) => {
      $scope.$broadcast('SHOW_REPORT_DATE_FILTER_REQUEST', data)
    })
    $scope.$on('LOAD_DEVICE_DETAILS_REQUEST', (e, data) => {
      loadDevice(data.id, data.requestId) // todo
    })
    const loadDevice = (id, requestId) => {
      const requestJson = {
        method: 'GET',
        url: `${EDGE_BASEURL}/edge/${id}`
      }
      $http(requestJson)
        .then(response => {
          if (response.data.status.code === 0) {
            edgeFactory.addOrUpdateItem(response.data.edge)
            $scope.$broadcast('LOAD_DEVICE_DETAILS_SUCCESS', { id, requestId })
          }
        })
        .catch(handleServerError)
    }

    $scope.$on(LOAD_DEVICE_DETAILS.REQUEST, (e, { imei }) => {
      if (!imei && $localStorage.deeplinkEventVideo) {
        imei = $localStorage.deeplinkEventVideo.edge_id
      }
      if (
        $localStorage.deeplinkEventVideo &&
        $localStorage.deeplinkEventVideo.type == 'show_event_video'
      ) {
        edgeFactoryV2.getImeiByEdgeId(imei).then(data => {
          imei = data.edge.uri
          loadDeviceV2(imei)
        })
      } else {
        loadDeviceV2(imei)
      }
    })

    $scope.$on('LOAD_GROUP_DETAILS_REQUEST', (e, data) => {
      loadGroup(data.id, data.requestId)
    })

    const loadDeviceV2 = imei => {
      if (
        $localStorage.deeplinkEventVideo &&
        $localStorage.deeplinkEventVideo.show &&
        !$localStorage.deeplinkEventVideo.shown
      ) {
        $rootScope.currentUserOrganization.id =
          $localStorage.deeplinkEventVideo.orgId
      }
      edgeFactoryV2
        .getSingleDevice($rootScope.currentUserOrganization.id, imei)
        .then(device => {
          edgeFactoryV2.addOrUpdateItem(device)
          $scope.$broadcast(LOAD_DEVICE_DETAILS.RESPONSE, {
            imei: imei || device.imei
          })
        })
        .catch(handleServerError)
    }

    const loadGroup = (id, requestId = false) => {
      const requestJson = {
        method: 'GET',
        url: `${EDGE_BASEURL}/edge_groups/${id}`
      }
      $http(requestJson)
        .then(response => {
          if (response.data.status.code === 0) {
            edgeGroupFactory.addOrUpdateItem(response.data.edgeGroup)
            $scope.$broadcast('LOAD_GROUP_DETAILS_SUCCESS', { id, requestId })
          }
        })
        .catch(handleServerError)
    }
    $scope.loadBroadcastViews = function () {
      if ($localStorage.isResellerSso) return
      if (
        $localStorage.deeplinkEventVideo &&
        $localStorage.deeplinkEventVideo.show &&
        !$localStorage.deeplinkEventVideo.shown
      ) {
        $rootScope.currentUserOrganization.id =
          $localStorage.deeplinkEventVideo.orgId
      }
      var requestJson = {
        method: 'GET',
        url:
          BROADCAST_BASEURL +
          '/organizationUserBroadcastViews/' +
          $rootScope.currentUserOrganization.id
      }
      $http(requestJson).then(function (response) {
        if (response.data.status.code === 0) {
          $scope.defaultView = false
          response.data.broadcastViews.forEach(function (broadcastView) {
            if (broadcastView.type === 1) {
              $scope.defaultView = broadcastView
              $scope.$broadcast('broadcastViewReceive', {
                broadcastViewData: broadcastView.broadcastViewData,
                broadcastViewId: broadcastView.id
              })
            }
            broadcastViewFactory.addOrUpdateItem(broadcastView)
          })
        }
      })
    }
    $scope.loadBroadcastViews()
    $scope.showVersionData = function () {
      $mdDialog
        .show({
          controller: 'versionController',
          templateUrl:
            './templates/version.modal.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          function (response) {},
          function () {}
        )
    }

    function handleServerError (response) {
      if (response && response.data) {
        if (response.data.statusCode === 401) {
          delete $localStorage.userToken
          delete $localStorage.userDetails
          delete $localStorage.userOrganization
          $state.go('home.login')
        } else if (
          response.data.statusCode === 403 ||
          (response.data.statusCode === 401 && response.data.type === 2)
        ) {
          $scope.showMessageToast($filter('translate')('accessDenied'))
        }
      } else {
        console.error(response)
      }
    }
    const refreshUserPermissions = () => {
      try {
        if (!$localStorage.userDetails) return
        const actualUserPermissionLevel =
          $localStorage.userDetails.permission_role
        const userPermissionLevel =
          $localStorage.userDetails.organizationId ===
          $localStorage.currentUserOrganization.id
            ? actualUserPermissionLevel
            : 'administrator'
        const operationsPermissions = require('cloud-utils/config/operation-permissions/default')
        const allowedOperations = {}
        const deniedOperations = {}
        Object.keys(operationsPermissions).forEach(operationKey => {
          const operationPermissions = operationsPermissions[operationKey]
          operationPermissions.allow.indexOf(userPermissionLevel) > -1 &&
            (allowedOperations[operationKey] = true)
          operationPermissions.deny.indexOf(userPermissionLevel) > -1 &&
            (deniedOperations[operationKey] = true)
        })
        $rootScope.allowedOperations = allowedOperations
        $rootScope.deniedOperations = deniedOperations
      } catch (error) {
        console.error(error)
        console.log(
          'allowedOperations',
          JSON.stringify($rootScope.allowedOperations)
        )
        console.log(
          'deniedOperations',
          JSON.stringify($rootScope.deniedOperations)
        )
      }
    }
    refreshUserPermissions()
    $rootScope.$on('refreshUserPermissions', refreshUserPermissions)
    $rootScope.getCameraNameByStreamId = (edge, streamId) =>
      window.getCameraNameByStreamId($filter('translate'), edge, streamId)
    $scope.$on(
      'devicesOnlineStatusRequest',
      (_, { serialNumbers, includeLastLocation = true }) => {
        $http({
          method: 'POST',
          url: EDGE_BASEURL + '/rpc-devices-tunnel-status',
          data: {
            serialNumbers
          },
          headers: {
            'x-hide-original-mqtt-device-state': false
          }
        })
          .then(response => {
            response.data.devices.forEach(
              d => (d.includeLastLocation = includeLastLocation)
            )
            $scope.$broadcast(
              'devicesOnlineStatusResponse',
              response.data.devices
            )
          })
          .catch(error => {
            handleServerError(error)
          })
      }
    )

    $scope.$on('deviceCamerasStatusRequest', (_, { serialNumber }) => {
      let cameraIds = []
      $http({
        method: 'GET',
        url: `${MEDIACORE_BASEURL}/rpc-device-active-cameras/${serialNumber}`,
        headers: {
          'x-media-token': $localStorage.userMediaAccessToken
        }
      })
        .then(({ data }) => {
          if (data.data.cameras) {
            cameraIds = data.data.cameras.sort()
          }
        })
        .catch(ex => {
          handleServerError(ex)
        })
        .finally(() => {
          $scope.$broadcast('deviceCamerasStatusResponse', {
            serialNumber,
            cameraIds
          })
        })
    })
    $rootScope.getDeviceSematicVersion = async serialNumber => {
      const requestJson = {
        method: 'GET',
        url: `${DEVICEMANAGER_BASEURL}/device/${serialNumber}/diagnostics`
      }
      const response = await $http(requestJson)
      return response.data.system_version.semantic_version
    }
    $rootScope.getDeviceOnlineStatus = async serialNumber => {
      const requestJson = {
        method: 'POST',
        url: `${EDGE_BASEURL}/rpc-devices-tunnel-status`,
        data: {
          serialNumbers: [serialNumber]
        },
        headers: {
          'x-hide-original-mqtt-device-state': false
        }
      }
      const response = await $http(requestJson)
      return response.data.devices.pop()
    }
    // start notification polling
    startNotificationPolling()
  }
])
